<template>
    <BaseForm v-if="series">
        <template #fields>
            <MultiLink
                :label="$t('other-documents')"
                :links="values.otherDocuments"
                :error-messages="errors.otherDocuments"
                @input="setFieldValue('otherDocuments', $event)"
                @delete="setFieldValue('otherDocuments', $event)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { useMultiLink } from '@/components/MultiLink/composables/useMultiLink';
import MultiLink from '@/components/MultiLink/MultiLink.vue';
import { useForm } from '@/forms/composables/useForm';
import { useProjectSeriesInjection } from '@/project/composables/useProjectSeriesInjection';
import { ProjectSeriesDocumentsSchema } from '@/project/schemas';
import { computed } from 'vue';

defineProps<{ seriesId: string }>();

const { series, createProjectSeriesMultiLink } = useProjectSeriesInjection();
const { getFormFieldLinks, saveMultiLinkFields } = useMultiLink(createProjectSeriesMultiLink);

const otherDocumentsId = computed(() => series.value?.otherDocuments?.id);
const otherDocumentsLinks = computed(() => series.value?.otherDocuments?.links.nodes ?? []);

const { values, errors, setFieldValue, validate, onDiscard, resetForm } = useForm(
    ProjectSeriesDocumentsSchema,
    computed(() => ({
        otherDocuments: getFormFieldLinks(otherDocumentsLinks),
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await saveMultiLinkFields([
            { id: otherDocumentsId.value, fieldName: 'otherDocuments', links: values.value.otherDocuments },
        ]);
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
